export const getCurrentUserInfo = ({ userInfo, isAssumed, assumedUserInfo }) => {
  return isAssumed ? assumedUserInfo : userInfo;
};
